import apiService from "../../../../services/apiService";
import React, { useState, useEffect } from "react";
import useStyles from "./DepartmentHistory.styles";
import { Typography, CircularProgress } from "@material-ui/core";

const DepartmentHistory = ({ personId, actionColors }) => {
    const classes = useStyles();
    const [history, setHistory] = useState([]);
    const [actionsMap, setActionsMap] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [nicknamesMap, setNicknamesMap] = useState({});

    useEffect(() => {
        const fetchActions = async () => {
            try {
                const response = await apiService.get("/departmentActions");
                const map = {};
                response.data.forEach((action) => {
                    map[action._id] = action.actionName;
                });
                setActionsMap(map);
            } catch (err) {
                console.error("שגיאה בטעינת רשימת הפעולות", err);
            }
        };
        fetchActions();
    }, []);

    useEffect(() => {
        if (!personId) return;

        const fetchHistory = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await apiService.get(`/departmentsUpdate/history/${personId}`);
                setHistory(response.data);
            } catch (err) {
                setError("שגיאה בטעינת ההיסטוריה");
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, [personId]);

    useEffect(() => {
        const fetchNicknames = async () => {
            const idsToFetch = [...new Set(history.map((item) => item.updatedBy))].filter(
                (id) => id && !nicknamesMap[id]
            );

            if (idsToFetch.length === 0) return;

            const updatedMap = { ...nicknamesMap };

            await Promise.all(
                idsToFetch.map(async (id) => {
                    try {
                        const response = await apiService.post("/users/getUserNicknameById", { userId: id });
                        updatedMap[id] = response.data.nickname || id;
                    } catch (err) {
                        console.error(`שגיאה בשליפת nickname ל־${id}:`, err);
                        updatedMap[id] = id;
                    }
                })
            );
            setNicknamesMap(updatedMap);
        };

        if (history.length) {
            fetchNicknames();
        }
    }, [history]);

    return (
        <div className={classes.container}>
            <Typography variant="h6">היסטוריה</Typography>
            {loading ? (
                <CircularProgress />
            ) : error ? (
                <Typography color="error">{error}</Typography>
            ) : history.length === 0 ? (
                <Typography>לא נבחרו פריטים עדיין.</Typography>
            ) : (
                <div className={classes.historyWrapper}>
                    <ul className={classes.list}>
                        {history.map((item, index) => (
                            <li key={item._id || index} className={classes.listItem}>
                                <b
                                    className={classes.actionLabel}
                                    style={{
                                        backgroundColor: actionColors?.[item.action] || "#fff",
                                    }}
                                >
                                    פעולה: {actionsMap[item.action] || item.action}
                                </b>
                                {item.action === 2 && (
                                    <>
                                        <br />
                                        <span>
                                            מספר מנות: {item.mealsCount != null ? item.mealsCount : 1}
                                        </span>
                                    </>
                                )}
                                <br />
                                <span>עודכן על ידי: {nicknamesMap[item.updatedBy] || item.updatedBy}</span>
                                <br />
                                <span>תאריך: {new Date(item.createdAt).toLocaleString()}</span>
                                {item.actionDescription && item.actionDescription.trim() !== "" && (
                                    <>
                                        <br />
                                        <span>תיאור: {item.actionDescription}</span>
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default DepartmentHistory;
